import React, { useEffect, useState } from 'react';
import { apiService } from '../services/apiService';
import { authService } from '../services/authService';
import TaskSubNav from '../components/TaskSubNav';
import { DSPageHeader, DSButton, DSIcon } from '../design-system/primitives';
import StatusBadge from '../components/StatusBadge';
import './taskManagementShared.css';

// Rank is carried by the tone, not by three different glyphs - the design system has
// one medal icon and three status colours, which is the same information with fewer
// parts and no reliance on platform emoji rendering.
const MEDAL_TONES = ['warning', 'muted', 'brand'];

function TaskLeaderboard() {
  const [period, setPeriod] = useState('month');
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    setCurrentUser(authService.getCurrentUser());
  }, []);

  useEffect(() => {
    setLoading(true);
    apiService.getTaskLeaderboard(period)
      .then((res) => setLeaderboard(res.data?.leaderboard || []))
      .catch((err) => setError(err.response?.data?.error || 'Unable to load leaderboard'))
      .finally(() => setLoading(false));
  }, [period]);

  return (
    <div className="tm-page">
      <DSPageHeader title="Task Leaderboard" />

      <div className="tm-filters">
        <DSButton appearance={period === 'month' ? 'solid' : 'outline'} tone="primary" size="sm" onClick={() => setPeriod('month')}>This Month</DSButton>
        <DSButton appearance={period === 'all' ? 'solid' : 'outline'} tone="primary" size="sm" onClick={() => setPeriod('all')}>All Time</DSButton>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading-inline">Loading...</div>
      ) : leaderboard.length === 0 ? (
        <div className="tm-empty-state"><h2>No contributions yet for this period</h2></div>
      ) : (
        <div className="tm-card-list">
          {leaderboard.map((entry) => (
            <div key={entry.user_id} className={`tm-leaderboard-row ${entry.user_id === currentUser?.id ? 'is-you' : ''}`}>
              <span className="tm-leaderboard-rank">
                {MEDAL_TONES[entry.rank - 1]
                  ? <DSIcon name="medal" tone={MEDAL_TONES[entry.rank - 1]} label={`Rank ${entry.rank}`} />
                  : `#${entry.rank}`}
              </span>
              <div className="tm-leaderboard-name">
                {entry.name} {entry.user_id === currentUser?.id && <StatusBadge variant="neutral" size="sm">You</StatusBadge>}
                <div className="tm-suggestion-meta">{entry.tasks_completed} tasks · {entry.badge_count} badges</div>
              </div>
              <strong>{entry.points} pts</strong>
            </div>
          ))}
        </div>
      )}
      <TaskSubNav />
    </div>
  );
}

export default TaskLeaderboard;
